import React from 'react';
import PropTypes from 'prop-types';

// Utils
import { isArray, isEqual } from 'lodash';
import { useTranslation } from 'react-i18next';
import cn from '../../../utils/tools/cn';

// Components
import FlashMessage from '../FlashMessage/FlashMessage';

import styles from './TagsInput.module.scss';

function TagsInput({
  options, selected, setFieldValue, setFieldTouched, name, isMulti, error,
}) {
  const { t } = useTranslation();

  const handleChange = (option) => {
    setFieldTouched(name, true);

    if (isMulti) {
      if (selected?.some((val) => val.value === option.value)) {
        setFieldValue(name, selected?.filter((op) => op.value !== option.value));
      } else {
        setFieldValue(name, isArray(selected) ? [...selected, option] : [option]);
      }
    } else {
      setFieldValue(name, !isEqual(selected, option) ? option : null);
    }
  };

  const isSelected = (value) => {
    if (isMulti) {
      return selected?.some((op) => (op.value === value));
    }
    return selected?.value === value;
  };

  return (
    <div>
      <div className="d-flex f-wrap">
        {options?.map((option, index) => (
          <button
            key={index}
            type="button"
            onClick={() => handleChange(option)}
            className={cn([styles.tag, 'd-flex center c-pointer', isSelected(option.value) ? styles.active : ''])}
          >
            {option.label}
          </button>
        ))}
      </div>

      {error ? (
        <div id={`error_${name}`} className="m-t-10">
          <FlashMessage message={t(error)} color="error" />
        </div>
      ) : null}
    </div>
  );
}

TagsInput.propTypes = {
  options: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.shape({})), PropTypes.shape({})]),
  selected: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.shape({})), PropTypes.shape({})]),
  setFieldValue: PropTypes.func,
  setFieldTouched: PropTypes.func,
  name: PropTypes.string,
  isMulti: PropTypes.bool,
  error: PropTypes.string,
};

TagsInput.defaultProps = {
  options: null,
  selected: null,
  setFieldValue: () => {},
  setFieldTouched: () => {},
  name: null,
  isMulti: false,
  error: null,
};

export default TagsInput;
